import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Storage } from '@ionic/storage'

import { URL_SERVICIOS_LOCALES, NUBE_AWS, URL_SERVICIOS_AWS, URL_SERVICIOS_AWS_IMAGE } from '../../config/url.servicio'

@Injectable()
export class ProductosElaboradosProvider {
  token:string

  constructor(public http: Http, private storage: Storage) {
    this.storage.get('token').then((val) => {
      this.token = val
    });
  }

  buscar() {
    let url = URL_SERVICIOS_LOCALES
    return this.http.get(`${url}/query?name=  `)
    .map((data) => data.json())
  }

  buscarProductoElaboradosCompania(companias:any) {
    let url = URL_SERVICIOS_LOCALES
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "buscarProductoElaboradosCompania",
        parameters : {companiasId: companias}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      let valor = parseInt(companias)
      return this.http.get(`${url}/proceso/buscarProductoElaboradosCompania?companiasId=${valor}`)
      .map((data) => data.json())
    }
  }

  guardarImagen(producto: any, typeImg: any) {
    var data = new FormData();
    data.append('file', producto.imagen)
    let url_servicio_aws_image = URL_SERVICIOS_AWS_IMAGE
    return this.http.post(`${url_servicio_aws_image}/dev/image-upload`, data)
      .map((data) =>  data.json())
  }


  guardar(producto: any, typeImg) {
    if(NUBE_AWS) {
      const url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "dataDynamicCrud",
        parameters : {
                      ...producto
                    }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
   }
    else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'authorization': 'Bearer ' + this.token
      })
      let options = new RequestOptions({
        headers: headers
      })

      var data = new FormData();
      data.append('codigoProducto', producto.codigoProducto)
      data.append('nombreProducto', producto.nombreProducto)
      data.append('imagen', new Blob([producto.imagen], {type: typeImg}))
      data.append('valorVenta', producto.valorVenta)
      data.append('companiasId', producto.companiasId)
      data.append('tipoImpuesto', producto.tipoImpuesto)
      data.append('valorImpuesto', producto.valorImpuesto)
      data.append('codigoBarra', producto.codigoBarra)

      return this.http.post(`${url}/productosElaborados`, data, options)
        .map((data) => data.json())
   }
  }

  editar(producto, typeImg) {
    let url = URL_SERVICIOS_LOCALES
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: producto.name,
        parameters : {...producto}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let headers = new Headers({
        'authorization': 'Bearer ' + this.token
      })
      let options = new RequestOptions({
        headers: headers
      })

      var data = new FormData();
      data.append('codigoProducto', producto.codigoProducto)
      data.append('nombreProducto', producto.nombreProducto)

      // verificar si se modifico el productosElaborados
      try {
        if( producto.imagen.indexOf('http') > -1 ){
          data.append('imagen', producto.imagen)
        } else {
          data.append('imagen', new Blob([producto.imagen], {type: typeImg}))
        }
      } catch (error) {
        data.append('imagen', new Blob([producto.imagen], {type: typeImg}))
      }

      data.append('valorVenta', producto.valorVenta)
      data.append('companiasId', producto.companiasId)
      data.append('productosElaboradosId', producto.productosElaboradosId)
      data.append('tipoImpuesto', producto.tipoImpuesto)
      data.append('valorImpuesto', producto.valorImpuesto)

      return this.http.put(`${url}/productosElaborados`, data, options)
        .map((data) => data.json())
   }
  }

  eliminar(producto: any) {
    let url = URL_SERVICIOS_LOCALES
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: producto.name,
        parameters : {
          name : "dataDynamicCrud",
          queHago: "E",
          productosElaboradosId : producto.productosElaboradosId,
          nombreTabla: "productosElaborados"
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })

      return this.http.delete(`${url}/query?name=dataDynamicCrud&queHago=E&productosElaboradosId=${producto.productosElaboradosId}&nombreTabla=productosElaborados`, options)
    }
 }

 buscarParametroGeneralIp(companias:any) {
  let url = URL_SERVICIOS_LOCALES
  if(NUBE_AWS) {
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "buscarParametroGeneralIp",
      parameters : {companiasId: companias}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
  } else {
    let url = URL_SERVICIOS_LOCALES
    let valor = parseInt(companias)
    return this.http.get(`${url}/proceso/buscarParametroGeneralIp?companiasId=${valor}`)
    .map((data) => data.json())
  }
}
}



// WEBPACK FOOTER //
// ./src/providers/productos-elaborados/productos-elaborados.ts